// https://vuex.vuejs.org/en/getters.html

export default {
    role(state) {
        return state.role;
    },
    isParish(state) {
        return state.isParish;
    },
    lastLocation(state) {
        return state.lastLocation;
    },
    userLocations(state) {
        return state.userLocations;
    },
    hasDelegations(state) {
        return state.hasDelegations;
    },
};
